import './switcher/switcher.css';
import React, {
  useRef, useLayoutEffect, useEffect, useState,
} from 'react';
import { useMediaQuery, makeStyles } from '@material-ui/core';
import { SwitcherControl } from './switcher/switcher';
import deviceCategories from '../common/deviceCategories';
import { prepareIcon, loadImage, loadCategoryImages, prepareStopAccIcon, prepareDeviceImageIcon } from './mapUtil';
import {
  styleCarto, styleLocationIq, styleMapbox, styleMapTiler, styleOsm,
} from './mapStyles';
import palette from '../theme/palette';
import { useTranslation } from '../LocalizationProvider';
import { BASE_SITE_URL, MACHINE_ENVIRONMENT, REACT_APP_MAPTILER_API_KEY } from "../config/constant";

//import maptilter
import * as maptiler from '@maptiler/sdk';
import '@maptiler/sdk/dist/maptiler-sdk.css';
import { addSufixToFileName, api_call } from '../helpers/untils';
import { useSelector } from 'react-redux';
maptiler.config.apiKey = REACT_APP_MAPTILER_API_KEY
// Opt out of MapTiler SDK telemetry (POST to api.maptiler.com/metrics) to avoid the extra cross-origin request.
maptiler.config.telemetry = false

const useStyles = makeStyles((theme) => ({
  mapCanvas: {
    '& div': {
      '& div': {
        '& .maplibregl-canvas': {
          opacity: MACHINE_ENVIRONMENT === 'dev' ? 1 : 1
        }
      }
    }
  }
}));

const element = document.createElement('div');
element.style.width = '100%';
element.style.height = '100%';

export const map = new maptiler.Map({
  container: element,
  style: maptiler.MapStyle.STREETS, // style URL
  center: [0, 0],
  zoom: 2,
  geolocateControl: false,
});

const Map = (props) => {
  const { children, shareUrl } = props;
  const classes = useStyles();
  const user = useSelector((state) => state.session.user);
  const containerEl = useRef(null);
  const t = useTranslation();
  const switcherRef = useRef(null);
  const mapInitedRef = useRef(false);
  const readyRef = useRef(false);
  const deviceReloadTimestamp = useSelector((state) => state.layout.deviceReloadTimestamp);
  const [mapReadyState, setMapReadyState] = useState(false);

  const updateReadyValue = (value) => {
    if (!readyRef.current) {
      console.log(`updateReadyValue::::::::::::::::::::::::::`, value)
      readyRef.current = value;
      setMapReadyState(value)
    }
  }

  const initMap = async () => {
    if (readyRef.current) return;
    if (mapInitedRef.current) {
      return false;
    }
    console.log(`initMap started::::::::::::::::::::::::::`);
    mapInitedRef.current = true;
    ////////////////////////////////////////////////////////////////////////////////////////////////////////
    let deviceImageList = [];
    if (user?.id) {
      if (!user.administrator) {
        const url = `/api/map-devices/main`;
        const response = await api_call(url);
        if (response.ok) {
          const apiRes = await response.json();
          deviceImageList = apiRes
        }
      }
    }
    else if (shareUrl) {
      const url = `/api/temporary/map-devices/main?shareUrl=${shareUrl}`;
      const response = await api_call(url);
      if (response.ok) {
        const apiRes = await response.json();
        deviceImageList = apiRes
      }
    }

    const background = await loadImage('/images/background.svg');
    if (!map.hasImage('background')) {
      map.addImage('background', await prepareIcon(background), {
        pixelRatio: window.devicePixelRatio,
      });
    }

    if (!map.hasImage('stop-acc')) {
      map.addImage('stop-acc', await prepareStopAccIcon(background), {
        pixelRatio: window.devicePixelRatio,
      });
    }

    const categoryImages = await loadCategoryImages()
    const colorList = ['Black', 'White', 'Brown', 'Gray', 'Red', 'Blue', 'Green', 'Silver', 'Gold', 'Yellow']
    const accList = [0, 1]
    const accIcon = await loadImage(`/images/accIcon-1.jpg`)
    //const overSpeedList = [0, 1]
    //const overSpeedIcon = await loadImage(`/images/overSpeedIcon-1.png`)

    for (let k in deviceCategories) {
      let category = 'Default';
      if (deviceCategories[k]) {
        category = deviceCategories[k];
      }
      const icon = categoryImages[category]
      for (let i in colorList) {
        const color = colorList[i]
        for (let b in accList) {
          const acc = accList[b]
          if (!map.hasImage(`${category}-${color}-${acc}`)) {
            const iconObj = acc === 1 ? accIcon : null
            map.addImage(`${category}-${color}-${acc}`, await prepareIcon(background, icon, palette.common[color], iconObj), {
              pixelRatio: window.devicePixelRatio,
            });
          }
        }
      }
    }

    if (!user?.administrator && MACHINE_ENVIRONMENT !== 'testLiveDB') {
      for (let j in deviceImageList) {
        const deviceImageUri = deviceImageList[j]['image']
        const deviceImage = await loadImage(`${MACHINE_ENVIRONMENT === "dev" ? 'http://127.0.0.1' : BASE_SITE_URL}/${addSufixToFileName(deviceImageUri)}`)
        for (let b in accList) {
          const acc = accList[b]
          if (!map.hasImage(`${deviceImageUri}-${acc}`)) {
            const iconObj = acc === 1 ? accIcon : null
            map.addImage(`${deviceImageUri}-${acc}`, await prepareDeviceImageIcon(background, deviceImage, palette.common['white'], iconObj), {
              pixelRatio: window.devicePixelRatio,
            });
          }
        }
      }
    }

    console.log(`initMap all icons loaded::::`)

    updateReadyValue(true);

  }

  useEffect(() => {
    if (deviceReloadTimestamp && deviceReloadTimestamp > 0) {
      mapInitedRef.current = false;
      initMap()
    }
  }, [deviceReloadTimestamp])

  useEffect(() => {
    if (!switcherRef.current) {
      switcherRef.current = new SwitcherControl(
        () => updateReadyValue(false),
        () => {
          const waiting = () => {
            if (!map.loaded()) {
              setTimeout(waiting, 100);
            } else {
              initMap();
            }
          };
          waiting();
        },
      );

      map.addControl(switcherRef.current);
    }
  }, []);

  // const mapTilerKey = useAttributePreference('mapTilerKey');
  // const locationIqKey = useAttributePreference('locationIqKey', 'pk.0f147952a41c555a5b70614039fd148b');

  useEffect(() => {
    switcherRef.current.updateStyles([
      // { id: 'locationIqStreets', title: t('mapLocationIqStreets'), uri: styleLocationIq('streets', locationIqKey) },
      // { id: 'locationIqEarth', title: t('mapLocationIqEarth'), uri: styleLocationIq('earth', locationIqKey) },
      // { id: 'locationIqHybrid', title: t('mapLocationIqHybrid'), uri: styleLocationIq('hybrid', locationIqKey) },
      { id: 'osm', title: t('mapOsm'), uri: styleOsm() },
      // { id: 'carto', title: t('mapCarto'), uri: styleCarto() },
      // { id: 'mapboxStreets', title: t('mapMapboxStreets'), uri: styleMapbox('streets-v11') },
      // { id: 'mapboxOutdoors', title: t('mapMapboxOutdoors'), uri: styleMapbox('outdoors-v11') },
      // { id: 'mapboxSatellite', title: t('mapMapboxSatellite'), uri: styleMapbox('satellite-v9') },
      // { id: 'mapTilerBasic', title: t('mapMapTilerBasic'), uri: styleMapTiler('basic', mapTilerKey) },
      // { id: 'mapTilerHybrid', title: t('mapMapTilerHybrid'), uri: styleMapTiler('hybrid', mapTilerKey) },
    ], 'osm');
  }, [switcherRef.current]);

  // useEffect(() => {
  //   const listener = (ready) => setMapReady(ready);
  //   addReadyListener(listener);
  //   return () => {
  //     removeReadyListener(listener);
  //   };
  // }, []);

  useLayoutEffect(() => {
    const currentEl = containerEl.current;
    currentEl.appendChild(element);
    map.resize();
    return () => {
      currentEl.removeChild(element);
    };
  }, [containerEl]);

  return (
    <div className={classes.mapCanvas} style={{ width: '100%', height: '100%' }} ref={containerEl}>
      {mapReadyState && children}
    </div>
  );
};

export default Map;
